import { Box, BoxProps, ColorOptions, Icon, Spacer, Text } from '@jfs/ui-new'
import { DropdownOptimised } from '../../comps/DropdownNew'
import { DropdownTypes } from '../../comps/DropdownNew/types'
import { SvgImage } from '../../comps/SvgImage'
import { dateRangeData } from '../../data/static/data'
import { Colors } from '../../util/util'

const Payouts = () => {
  const onDateRangeSelected = (val) => {
    console.log(val)
  }
  return (
    <Box f={1} overflow={'auto'}>
      <Box flexDirection={'row'} gap={16} p={16}>
        <Box {...styles.chartContainer}>
          <Box flexDirection={'row'} align={'flex-start'} justify={'space-between'}>
            <Text title={'Total Payouts'} fontFamily={'jiotype-medium'} fontSize={14} color={'BLACK_21'} />
            <DropdownOptimised
              placeHolder={'Daily'}
              iconType="CALENDAR"
              onChange={onDateRangeSelected}
              data={dateRangeData}
              type={DropdownTypes.DEFAULT_WITH_IMAGE as DropdownTypes}
            />
          </Box>
          <Spacer size={12} direction={'vertical'} />
          <Box flexDirection={'row'} align={'center'}>
            <Text title={'₹1,08,452.00'} fontFamily={'jiotype-bold'} fontSize={20} color={'BLACK_21'} />
            <Spacer direction={'horizontal'} size={8} />
            <SvgImage imageName={'UpArrow'} />
            <Text title={'5%'} fontFamily={'jiotype-bold'} fontSize={14} color={'BRAND_PRIMARY_GREEN'} />
          </Box>
          <Box>chart</Box>
        </Box>
        <Box {...styles.balancesContainer}>
          <Box flexDirection={'row'} align={'center'} justify={'space-between'}>
            <Text title={'Total Balance'} fontFamily={'jiotype-medium'} fontSize={14} color={'BLACK_21'} />
            <Box flexDirection={'row'} align={'center'}>
              <Text title={'Statement'} fontFamily={'jiotype-medium'} fontSize={14} color={'PRIMARY'} />
              <Icon id={'ARROW_RIGHT'} size={12} color={'PRIMARY'} />
            </Box>
            <Spacer direction={'horizontal'} size={16} />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

const shadowStyle = {
  shadowColor: 'GRAY_SHADOW',
  shadowOffset: {
    width: 1,
    height: 2,
  },
  shadowOpacity: 0.6,
  shadowRadius: 2,
  elevation: 2,
}

const styles = {
  chartContainer: {
    borderWidth: 1,
    f: 0.75,
    borderRadius: 8,
    borderColor: Colors.GREY_BORDER as ColorOptions,
    pv: 25,
    ph: 20,
    bg: 'WHITE',
    ...shadowStyle,
  } as BoxProps,
  balancesContainer: {
    borderWidth: 1,
    f: 0.25,
    borderRadius: 8,
    borderColor: Colors.GREY_BORDER as ColorOptions,
    p: 16,
    bg: 'WHITE',
    ...shadowStyle,
  } as BoxProps,
}
export default Payouts
